import React from "react";

const Team = () => {
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      let top_space = 0;
      const header = document.getElementById("header");
      if (header) {
        top_space = header.offsetHeight;
        if (!header.classList.contains("header-scrolled")) {
          top_space -= 20;
        }
      }
      window.scroll({
        top: target.offsetTop - top_space,
        behavior: "smooth",
      });
    }
  };

  const members = [
    {
      name: "Ayaz Khan",
      role: "Founder & CEO",
      img: "img/team/team-1.jpg",
    },
    {
      name: "Jamal Khan",
      role: "Director of AI and Engineering",
      img: "img/team/team-2.jpg",
    },
    {
      name: "Asif Khan",
      role: "Partner and CMO",
      img: "img/team/team-3.jpg",
    },
    // {
    //   name: "Iman Khan",
    //   role: "CTO",
    //   img: "img/team/team-4.jpg",
    // },
    // {
    //   name: "Mues Khan",
    //   role: "Director of UX",
    //   img: "img/team/team-5.jpg",
    // },
  ];

  return (
    <>
      <style>{`
        #team .member {
          position: relative;
          background: rgba(255, 255, 255, 0.04) !important;
          border: 1px solid rgba(255, 255, 255, 0.08) !important;
          border-radius: 12px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          height: 100%;
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
        }
        #team .member:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
          border-color: #007bff !important;
          background: rgba(255, 255, 255, 0.07) !important;
        }
        #team .member img {
          width: 70%;
          height: 320px;
          object-fit: cover;
          display: block;
          transition: transform 0.5s ease;
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
          margin: auto;
        }
        #team .member:hover img {
          transform: scale(1.05);
        }
        #team .member-info {
          position: static !important;
          opacity: 1 !important;
          visibility: visible !important;
          padding: 20px 15px !important;
          text-align: center;
          background: transparent !important;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        #team .member-info h4 {
          color: #ffffff !important;
          margin: 0 0 6px 0 !important;
          font-size: 19px !important;
          font-weight: 700 !important;
        }
        #team .member-info span {
          color: #b2b8c9 !important;
          font-size: 14px !important;
          display: block;
          margin-bottom: 12px;
          font-weight: 400;
        }
      `}</style>
      {/*==========================
        Team Section
      ============================*/}
      <section id="team" style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="section-header">
            <h3>Our Team</h3>
            <p>
              Meet our talented leadership and engineering team, dedicated to crafting innovative digital solutions and pushing technological boundaries.
            </p>
          </div>

          <div className="row justify-content-center mt-5">
            {members.map((member, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-6 wow fadeInUp mb-4"
                data-wow-delay={`${index * 0.1}s`}
                style={{ margin: "auto" }}
              >
                <div className="member">
                  <img src={member.img} className="img-fluid" alt={member.name} />
                  <div className="member-info">
                    <h4>{member.name}</h4>
                    <span>{member.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row justify-content-center mt-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="col-lg-8 text-center">
              <p style={{ fontStyle: "italic", fontSize: "17px", color: "#b2b8c9" }}>
                ...and many more. <a href="#contact" onClick={(e) => handleSmoothScroll(e, "#contact")} style={{ color: "#007bff", fontWeight: "600", textDecoration: "underline" }}>Contact us</a> to know more about our team.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* #team */}
    </>
  );
};

export default Team;